import { Product } from "@/types/Products";
import { supabase } from "@/lib/supabaseClient";
// Helper function to get a date relative to now
const getRelativeDate = (daysAgo: number): string => {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date.toISOString();
};

export const mockProducts: Product[] = [
    {
        shopify_product_id: "123456789",
        shopify_variant_id: "987654321",
        merge_id: "987654321",
        product_name: "Classic Cotton T-Shirt",
        variant_name: "Small",
        sku: "CT-WH-S",
        price: 19.99,
        cost: 5.00,
        category: "Apparel",
        product_type: "T-Shirts",
        tags: ["summer", "basics", "bestseller"],
        status: "Optimized",
        is_converged: true,
        last_optimized: getRelativeDate(2),
        optimization_settings: {
            base_market: {
                cost: 5.00,
                currency: "GBP",
                max_price: 23.99,
                min_price: 15.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [65, 70, 75, 78, 72, 68, 62, 55, 48, 40],
                        visitors: [780, 790, 810, 830, 790, 760, 730, 700, 670, 640],
                        times: [172800, 172800, 172800, 172800, 172800, 172800, 172800, 172800, 172800],
                        prices: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                        product_cost: 5.00,
                        timestamps: [
                            getRelativeDate(20), getRelativeDate(18), getRelativeDate(16), 
                            getRelativeDate(14), getRelativeDate(12), getRelativeDate(10), 
                            getRelativeDate(8), getRelativeDate(6), getRelativeDate(4), getRelativeDate(2)
                        ],
                        best_prices: [19.99, 19.99, 21.99, 21.99, 23.99, 23.99, 23.99, 23.99, 23.99, 23.99],
                        best_ppv: 1.15,
                        best_metrics: null,
                        last_updated: getRelativeDate(2),
                        started_at: getRelativeDate(20),
                        current_test_price: 23.50,
                        plot_data: {
                            y_lower: [0.92, 0.98, 1.05, 1.10, 1.12, 1.08, 1.02, 0.95, 0.88, 0.80],
                            y_upper: [1.02, 1.08, 1.15, 1.20, 1.22, 1.18, 1.12, 1.05, 0.98, 0.90],
                            best_ppv: 1.15,
                            x_values: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                            y_values: [0.97, 1.03, 1.10, 1.15, 1.17, 1.13, 1.07, 1.00, 0.93, 0.85],
                            max_price: 33.99,
                            min_price: 15.99,
                            best_price: 23.99,
                            next_sample: 23.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 5.00,
                            x_values_data: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                            y_values_data: [0.97, 1.03, 1.10, 1.15, 1.17, 1.13, 1.07, 1.00, 0.93, 0.85]
                        },
                        original_price: 19.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: true,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(30),
        is_demo: true
    },
    {
        shopify_product_id: "123456790",
        shopify_variant_id: "987654322",
        merge_id: "987654321",
        product_name: "Classic Cotton T-Shirt",
        variant_name: "Medium",
        sku: "CT-BL-M",
        price: 19.99,
        cost: 5.00,
        category: "Apparel",
        product_type: "T-Shirts",
        tags: ["summer", "basics"],
        status: "Not started",
        is_converged: false,
        last_optimized: null,
        optimization_settings: {
            base_market: {
                cost: 5.00,
                currency: "GBP",
                max_price: 23.99,
                min_price: 15.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: null,
        created_at: getRelativeDate(30),
        is_demo: true
    },
    {
        shopify_product_id: "123456791",
        shopify_variant_id: "987654323",
        merge_id: "987654321",
        product_name: "Classic Cotton T-Shirt",
        variant_name: "Large",
        sku: "CT-BL-L",
        price: 19.99,
        cost: 5.00,
        category: "Apparel",
        product_type: "T-Shirts",
        tags: ["summer", "basics"],
        status: "Not started",
        is_converged: false,
        last_optimized: null,
        optimization_settings: {
            base_market: {
                cost: 5.00,
                currency: "GBP",
                max_price: 23.99,
                min_price: 15.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: null,
        created_at: getRelativeDate(30),
        is_demo: true
    },
    {
        shopify_product_id: "123456792",
        shopify_variant_id: "987654324",
        product_name: "Premium Leather Wallet",
        variant_name: "Brown",
        sku: "PLW-BR",
        price: 49.99,
        cost: 15.00,
        category: "Accessories",
        product_type: "Wallets",
        tags: ["leather", "premium"],
        status: "Not started",
        is_converged: false,
        last_optimized: null,
        optimization_settings: {
            base_market: {
                cost: 15.00,
                currency: "GBP",
                max_price: 59.99,
                min_price: 39.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: null,
        created_at: getRelativeDate(20),
        is_demo: true
    },
    {
        shopify_product_id: "123456793",
        shopify_variant_id: "987654325",
        product_name: "Slim Cut Jeans",
        variant_name: "Default",
        sku: "WE-WH",
        price: 129.99,
        cost: 45.00,
        category: "Apparel",
        product_type: "Jeans",
        tags: ["trending"],
        status: "Optimizing",
        is_converged: false,
        last_optimized: getRelativeDate(1),
        optimization_settings: {
            base_market: {
                cost: 45.00,
                currency: "GBP",
                max_price: 155.99,
                min_price: 103.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [28, 32, 38, 45, 50, 48, 42, 35, 28, 22],
                        visitors: [420, 440, 460, 490, 510, 490, 460, 430, 400, 380],
                        times: [86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400],
                        prices: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                        product_cost: 45.00,
                        timestamps: [
                            getRelativeDate(10), getRelativeDate(9), getRelativeDate(8), 
                            getRelativeDate(7), getRelativeDate(6), getRelativeDate(5), 
                            getRelativeDate(4), getRelativeDate(3), getRelativeDate(2), getRelativeDate(1)
                        ],
                        best_prices: [129.99, 129.99, 139.99, 139.99, 149.99, 149.99, 149.99, 149.99, 149.99, 149.99],
                        best_ppv: 1.22,
                        best_metrics: null,
                        last_updated: getRelativeDate(1),
                        started_at: getRelativeDate(10),
                        current_test_price: 149.50,
                        plot_data: {
                            y_lower: [0.90, 0.98, 1.05, 1.15, 1.20, 1.15, 1.08, 1.00, 0.90, 0.80],
                            y_upper: [1.00, 1.08, 1.15, 1.25, 1.30, 1.25, 1.18, 1.10, 1.00, 0.90],
                            best_ppv: 1.22,
                            x_values: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                            y_values: [0.95, 1.03, 1.10, 1.20, 1.25, 1.20, 1.13, 1.05, 0.95, 0.85],
                            max_price: 199.99,
                            min_price: 109.99,
                            best_price: 149.99,
                            next_sample: 149.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 45.00,
                            x_values_data: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                            y_values_data: [0.95, 1.03, 1.10, 1.20, 1.25, 1.20, 1.13, 1.05, 0.95, 0.85]
                        },
                        original_price: 129.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: false,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(15),
        is_demo: true
    },
    {
        shopify_product_id: "123456794",
        shopify_variant_id: "987654326",
        product_name: "5 pack cotton sports socks",
        variant_name: "Default",
        sku: "YM-PR",
        price: 29.99,
        cost: 8.00,
        category: "Apparel",
        product_type: "Socks",
        tags: ["basics"],
        status: "Optimizing",
        is_converged: false,
        last_optimized: getRelativeDate(3),
        optimization_settings: {
            base_market: {
                cost: 8.00,
                currency: "GBP",
                max_price: 35.99,
                min_price: 23.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [42, 45, 48, 50, 48, 45, 40, 35, 30, 25],
                        visitors: [520, 530, 540, 550, 540, 520, 500, 480, 460, 440],
                        times: [86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400],
                        prices: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                        product_cost: 8.00,
                        timestamps: [
                            getRelativeDate(12), getRelativeDate(11), getRelativeDate(10), 
                            getRelativeDate(9), getRelativeDate(8), getRelativeDate(7), 
                            getRelativeDate(6), getRelativeDate(5), getRelativeDate(4), getRelativeDate(3)
                        ],
                        best_prices: [28.99, 28.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99],
                        best_ppv: 1.10,
                        best_metrics: null,
                        last_updated: getRelativeDate(3),
                        started_at: getRelativeDate(12),
                        current_test_price: 30.50,
                        plot_data: {
                            y_lower: [0.95, 1.00, 1.05, 1.08, 1.05, 1.00, 0.95, 0.90, 0.85, 0.80],
                            y_upper: [1.05, 1.10, 1.15, 1.18, 1.15, 1.10, 1.05, 1.00, 0.95, 0.90],
                            best_ppv: 1.10,
                            x_values: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                            y_values: [1.00, 1.05, 1.10, 1.13, 1.10, 1.05, 1.00, 0.95, 0.90, 0.85],
                            max_price: 41.99,
                            min_price: 24.99,
                            best_price: 29.99,
                            next_sample: 30.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 8.00,
                            x_values_data: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                            y_values_data: [1.00, 1.05, 1.10, 1.13, 1.10, 1.05, 1.00, 0.95, 0.90, 0.85]
                        },
                        original_price: 36.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: false,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(10),
        is_demo: true
    },
    {
        shopify_product_id: "123456795",
        shopify_variant_id: "987654327",
        product_name: "Sports vest",
        variant_name: "Standard Fabric",
        sku: "CT-WH-S",
        price: 19.99,
        cost: 5.00,
        category: "Apparel",
        product_type: "Vests",
        tags: ["summer", "basics"],
        status: "Optimized",
        is_converged: true,
        last_optimized: getRelativeDate(2),
        optimization_settings: {
            base_market: {
                cost: 5.00,
                currency: "GBP",
                max_price: 23.99,
                min_price: 15.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [65, 70, 75, 78, 72, 68, 62, 55, 48, 40],
                        visitors: [780, 790, 810, 830, 790, 760, 730, 700, 670, 640],
                        times: [172800, 172800, 172800, 172800, 172800, 172800, 172800, 172800, 172800],
                        prices: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                        product_cost: 5.00,
                        timestamps: [
                            getRelativeDate(20), getRelativeDate(18), getRelativeDate(16), 
                            getRelativeDate(14), getRelativeDate(12), getRelativeDate(10), 
                            getRelativeDate(8), getRelativeDate(6), getRelativeDate(4), getRelativeDate(2)
                        ],
                        best_prices: [19.99, 19.99, 21.99, 21.99, 23.99, 23.99, 23.99, 23.99, 23.99, 23.99],
                        best_ppv: 1.15,
                        best_metrics: null,
                        last_updated: getRelativeDate(2),
                        started_at: getRelativeDate(20),
                        current_test_price: 23.50,
                        plot_data: {
                            y_lower: [0.92, 0.98, 1.05, 1.10, 1.12, 1.08, 1.02, 0.95, 0.88, 0.80],
                            y_upper: [1.02, 1.08, 1.15, 1.20, 1.22, 1.18, 1.12, 1.05, 0.98, 0.90],
                            best_ppv: 1.15,
                            x_values: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                            y_values: [0.97, 1.03, 1.10, 1.15, 1.17, 1.13, 1.07, 1.00, 0.93, 0.85],
                            max_price: 33.99,
                            min_price: 15.99,
                            best_price: 23.99,
                            next_sample: 23.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 5.00,
                            x_values_data: [15.99, 17.99, 19.99, 21.99, 23.99, 25.99, 27.99, 29.99, 31.99, 33.99],
                            y_values_data: [0.97, 1.03, 1.10, 1.15, 1.17, 1.13, 1.07, 1.00, 0.93, 0.85]
                        },
                        original_price: 19.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: true,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(30),
        is_demo: true
    },
    {
        shopify_product_id: "123456796",
        shopify_variant_id: "987654328",
        product_name: "Sports vest",
        variant_name: "SuperTec Fabric",
        sku: "CT-BL-M",
        price: 19.99,
        cost: 5.00,
        category: "Apparel",
        product_type: "Vests",
        tags: ["summer", "basics"],
        status: "Optimized",
        is_converged: true,
        last_optimized: getRelativeDate(5),
        optimization_settings: {
            base_market: {
                cost: 5.00,
                currency: "GBP",
                max_price: 23.99,
                min_price: 15.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [58, 63, 68, 72, 70, 65, 60, 54, 48, 42],
                        visitors: [820, 830, 840, 850, 830, 810, 790, 770, 750, 730],
                        times: [259200, 259200, 259200, 259200, 259200, 259200, 259200, 259200, 259200],
                        prices: [16.99, 18.99, 19.99, 21.99, 22.99, 24.99, 26.99, 28.99, 30.99, 32.99],
                        product_cost: 5.00,
                        timestamps: [
                            getRelativeDate(25), getRelativeDate(22), getRelativeDate(19), 
                            getRelativeDate(16), getRelativeDate(13), getRelativeDate(10), 
                            getRelativeDate(8), getRelativeDate(7), getRelativeDate(6), getRelativeDate(5)
                        ],
                        best_prices: [19.99, 19.99, 19.99, 21.99, 21.99, 21.99, 21.99, 21.99, 21.99, 21.99],
                        best_ppv: 1.12,
                        best_metrics: null,
                        last_updated: getRelativeDate(5),
                        started_at: getRelativeDate(25),
                        current_test_price: 21.50,
                        plot_data: {
                            y_lower: [0.95, 1.00, 1.05, 1.10, 1.08, 1.04, 0.98, 0.92, 0.86, 0.80],
                            y_upper: [1.05, 1.10, 1.15, 1.20, 1.18, 1.14, 1.08, 1.02, 0.96, 0.90],
                            best_ppv: 1.12,
                            x_values: [16.99, 18.99, 19.99, 21.99, 22.99, 24.99, 26.99, 28.99, 30.99, 32.99],
                            y_values: [1.00, 1.05, 1.10, 1.15, 1.13, 1.09, 1.03, 0.97, 0.91, 0.85],
                            max_price: 32.99,
                            min_price: 16.99,
                            best_price: 21.99,
                            next_sample: 21.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 5.00,
                            x_values_data: [16.99, 18.99, 19.99, 21.99, 22.99, 24.99, 26.99, 28.99, 30.99, 32.99],
                            y_values_data: [1.00, 1.05, 1.10, 1.15, 1.13, 1.09, 1.03, 0.97, 0.91, 0.85]
                        },
                        original_price: 19.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: true,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(30),
        is_demo: true
    },
    {
        shopify_product_id: "123456797",
        shopify_variant_id: "987654329",
        product_name: "Lightweight fleece jacket",
        variant_name: "Default",
        sku: "PLW-BR",
        price: 49.99,
        cost: 15.00,
        category: "Apparel",
        product_type: "Jackets",
        tags: ["winter", "basics"],
        status: "Not started",
        is_converged: false,
        last_optimized: null,
        optimization_settings: {
            base_market: {
                cost: 15.00,
                currency: "GBP",
                max_price: 59.99,
                min_price: 39.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: null,
        created_at: getRelativeDate(20),
        is_demo: true
    },
    {
        shopify_product_id: "123456798",
        shopify_variant_id: "987654330",
        product_name: "Leather jacket",
        variant_name: "Default",
        sku: "WE-WH",
        price: 129.99,
        cost: 45.00,
        category: "Apparel",
        product_type: "Jackets",
        tags: ["winter", "basics"],
        status: "Optimizing",
        is_converged: false,
        last_optimized: getRelativeDate(1),
        optimization_settings: {
            base_market: {
                cost: 45.00,
                currency: "GBP",
                max_price: 155.99,
                min_price: 103.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [28, 32, 38, 45, 50, 48, 42, 35, 28, 22],
                        visitors: [420, 440, 460, 490, 510, 490, 460, 430, 400, 380],
                        times: [86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400],
                        prices: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                        product_cost: 45.00,
                        timestamps: [
                            getRelativeDate(10), getRelativeDate(9), getRelativeDate(8), 
                            getRelativeDate(7), getRelativeDate(6), getRelativeDate(5), 
                            getRelativeDate(4), getRelativeDate(3), getRelativeDate(2), getRelativeDate(1)
                        ],
                        best_prices: [129.99, 129.99, 139.99, 139.99, 149.99, 149.99, 149.99, 149.99, 149.99, 149.99],
                        best_ppv: 1.22,
                        best_metrics: null,
                        last_updated: getRelativeDate(1),
                        started_at: getRelativeDate(10),
                        current_test_price: 149.50,
                        plot_data: {
                            y_lower: [0.90, 0.98, 1.05, 1.15, 1.20, 1.15, 1.08, 1.00, 0.90, 0.80],
                            y_upper: [1.00, 1.08, 1.15, 1.25, 1.30, 1.25, 1.18, 1.10, 1.00, 0.90],
                            best_ppv: 1.22,
                            x_values: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                            y_values: [0.95, 1.03, 1.10, 1.20, 1.25, 1.20, 1.13, 1.05, 0.95, 0.85],
                            max_price: 199.99,
                            min_price: 109.99,
                            best_price: 149.99,
                            next_sample: 149.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 45.00,
                            x_values_data: [109.99, 119.99, 129.99, 139.99, 149.99, 159.99, 169.99, 179.99, 189.99, 199.99],
                            y_values_data: [0.95, 1.03, 1.10, 1.20, 1.25, 1.20, 1.13, 1.05, 0.95, 0.85]
                        },
                        original_price: 129.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: false,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(15),
        is_demo: true
    },
    {
        shopify_product_id: "123456799",
        shopify_variant_id: "987654331",
        product_name: "Dark tint sunglasses",
        variant_name: "Default",
        sku: "YM-PR",
        price: 29.99,
        cost: 8.00,
        category: "Accessories",
        product_type: "Sunglasses",
        tags: ["summer", "basics"],
        status: "Optimizing",
        is_converged: false,
        last_optimized: getRelativeDate(3),
        optimization_settings: {
            base_market: {
                cost: 8.00,
                currency: "GBP",
                max_price: 35.99,
                min_price: 23.99,
                presentation: "subunit_50"
            },
            markets: {
                "eu": {},
                "gb": {},
                "mexico": {},
                "international": {},
                "united-states": {}
            },
            enabled_markets: ["eu", "gb", "mexico", "international", "united-states"]
        },
        optimization_progress: {
            marketsets: [
                {
                    data: {
                        sales: [42, 45, 48, 50, 48, 45, 40, 35, 30, 25],
                        visitors: [520, 530, 540, 550, 540, 520, 500, 480, 460, 440],
                        times: [86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400, 86400],
                        prices: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                        product_cost: 8.00,
                        timestamps: [
                            getRelativeDate(12), getRelativeDate(11), getRelativeDate(10), 
                            getRelativeDate(9), getRelativeDate(8), getRelativeDate(7), 
                            getRelativeDate(6), getRelativeDate(5), getRelativeDate(4), getRelativeDate(3)
                        ],
                        best_prices: [28.99, 28.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99, 29.99],
                        best_ppv: 1.10,
                        best_metrics: null,
                        last_updated: getRelativeDate(3),
                        started_at: getRelativeDate(12),
                        current_test_price: 30.50,
                        plot_data: {
                            y_lower: [0.95, 1.00, 1.05, 1.08, 1.05, 1.00, 0.95, 0.90, 0.85, 0.80],
                            y_upper: [1.05, 1.10, 1.15, 1.18, 1.15, 1.10, 1.05, 1.00, 0.95, 0.90],
                            best_ppv: 1.10,
                            x_values: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                            y_values: [1.00, 1.05, 1.10, 1.13, 1.10, 1.05, 1.00, 0.95, 0.90, 0.85],
                            max_price: 41.99,
                            min_price: 24.99,
                            best_price: 29.99,
                            next_sample: 30.50,
                            y_stds_data: [0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.02],
                            product_cost: 8.00,
                            x_values_data: [24.99, 26.99, 28.99, 29.99, 31.99, 33.99, 35.99, 37.99, 39.99, 41.99],
                            y_values_data: [1.00, 1.05, 1.10, 1.13, 1.10, 1.05, 1.00, 0.95, 0.90, 0.85]
                        },
                        original_price: 36.99
                    },
                    markets: ["eu", "gb", "mexico", "international", "united-states"],
                    is_converged: false,
                    reset_scheduled: false,
                    new_price_scheduled: false
                }
            ]
        },
        created_at: getRelativeDate(10),
        is_demo: true
    }
];

export const mockShopData = {
    shop: "demo-shop.myshopify.com",
    last_product_sync: getRelativeDate(0.5), // 12 hours ago
    markets: ["GB", "US", "CA", "AU"]
}; 

export const resetMockData = async (userId: string) => {
    try {
      // First, delete all existing products for this user
      const { error: deleteError } = await supabase
        .from('products')
        .delete()
        .eq('user_id', userId);
      
      if (deleteError) {
        console.error('Error deleting existing products:', deleteError);
        return;
      }
      
      // Prepare mock data with the correct user_id
      const productsWithUserId = mockProducts.map(product => ({
        ...product,
        user_id: userId,
      }));
      
      // Insert the mock data
      const { data, error } = await supabase
        .from('products')
        .insert(productsWithUserId)
        .select();
      
      if (error) {
        console.error('Error inserting mock data:', error);
        return;
      }
      
      console.log('Mock data reset successful:', data);
      return data;
    } catch (error) {
      console.error('Error in resetMockData:', error);
    }
  };
  
  // ... existing code ...